import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { AuthService } from "./auth.service";
import { EventService } from "./event.service";
import { ApiCollectionResponse, User } from "../app/app.interfaces";

@Injectable()

export class UserService {

  
  constructor(private apiService: ApiService, 
              private authService: AuthService,
              private eventService: EventService
  ) {
    
  }

  public reloadAuthenticatedUser(user?: User): Promise<void> {
		
		return new Promise<void>((resolve) => {
  		
			if(user){
				this.authService.setUser(user);
				resolve();
			}
			else {
				this.apiService.getResourceById('users', this.authService.user.id).then((user: User) => {
					this.authService.setUser(user);
				resolve();
				});
			}
		});
  	

  }

  public searchUsersByName(name: string): Promise<User[]> {

  	return new Promise<User[]>((resolve) => {

			this.apiService.getCollection('users', { fullName: name }).then((apiResponse: ApiCollectionResponse) => {

				const users = apiResponse.items;
				console.log(users);
				resolve(users);

			}).catch((err) => {
				console.error(err);
				resolve([]);
			});

		}) ;


	}






  
  
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts